export default function BodyScanAnimation({
  videoToShow,
}: {
  videoToShow?: string;
}) {
  return (
    <div className="relative w-full h-full common-ui-main">
      <video
        className="h-full w-full object-contain border-none"
        muted
        autoPlay
        loop
        playsInline
      >
        <source src={videoToShow} type="video/mp4" />
      </video>
    </div>
  );
}
